// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"65f2ea65","699":"c2c8e579","842":"d64aa46c"}[chunkId] + ".chunk.css";
};